import axios from 'axios'
import Vuex from 'vuex'
import Vue from 'vue'
import store from '../store'

Vue.use(Vuex, axios)

export default {
  getPluginLayout(cb, errorCb) {
    const credential = store.getters['config/getCredential']
    var userLang = navigator.language || navigator.userLanguage
    var headerObj = {};
    if (credential) {
      if (!credential.locale) {
        credential.locale = userLang.replace('-', '_')
      }
      if (credential && credential.apiEncryptedUser) {
        headerObj = {
          'X-ApiEncryptedUser': credential.apiEncryptedUser
        }
      } else if (credential && credential.apiKey) {
        headerObj = {
          'X-ApiKey': credential.apiKey
        }
      }
    }
    axios
      .get(
        `${process.env.VUE_APP_BASE_URL}/plugin/layout`,
        {
          headers: headerObj
        }
      )
      .then(res => {
        cb(res)
      })
      .catch(error => {
        errorCb()
      })
  }
}
